import { render, staticRenderFns } from "./EcosystemNeedAddStartup.vue?vue&type=template&id=593338cf&scoped=true&"
import script from "./EcosystemNeedAddStartup.vue?vue&type=script&setup=true&lang=js&"
export * from "./EcosystemNeedAddStartup.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593338cf",
  null
  
)

export default component.exports